import { render, staticRenderFns } from "./VGallery.vue?vue&type=template&id=db17e4be&"
import script from "./VGallery.vue?vue&type=script&lang=js&"
export * from "./VGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports